import { nodes } from "./reactHelpers.jsx";
import { esc } from "../../utils/format.js";
export function detailRows(rows) {
  return nodes(
    rows.map(([k, v]) => (
      <div className={"detail-row"}>
        <span>{esc(k)}</span>
        <b>{esc(v == null || v === "" ? "— Not available" : v)}</b>
      </div>
    )),
  );
}
